import { Component, Input } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IHeroBannerTileInstance } from '../../../../interfaces/tiles/definitions/hero-banner-tile-definition.interface';
import {
  resolveSiteAssetCssValue,
  resolveSiteAssetUrl,
} from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-bi-hero-banner-tile',
  templateUrl: './hero-banner-tile.component.html',
  styleUrls: ['./hero-banner-tile.component.scss'],
})
export class HeroBannerTileComponent {
  @Input() tileInstance: IHeroBannerTileInstance;

  private get siteBaseUrl(): string {
    return this.tenantService.currentTenantData?.primaryWebUrl ?? '';
  }

  get contentImgPath(): string {
    return resolveSiteAssetUrl(this.tileInstance?.contentImg ?? '', this.siteBaseUrl);
  }

  get backgroundStyle(): string {
    return resolveSiteAssetCssValue(this.tileInstance?.background ?? '', this.siteBaseUrl);
  }

  constructor(private readonly tenantService: CurrentTenantService) {}

  scrollToElement(element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
}
